export default {
  hidden_rates:
    "Certains modes de paiement ont aussi leur propre taux, défini par le support de votre plateforme. Ceux-ci s'appliquent à la place de ce taux.",
  title: 'Frais de traitement',
  subtitle:
    'Les frais de traitement facturés à {{company}} sur les paiements en ligne, pour couvrir les frais de Stripe.',
  card_title: 'Frais de traitement',
  status: {
    inherited_tag: 'Par défaut du partenaire',
    inherited: 'Ce restaurant se voit appliquer vos frais de traitement par défaut.',
    custom_tag: 'Personnalisé',
    custom: 'Ce restaurant a ses propres frais de traitement, qui remplacent vos frais par défaut.',
    none_title: 'Aucun frais de traitement défini',
    none: 'Ni ce restaurant ni votre valeur par défaut n’ont de taux. Sauf si vous avez confirmé une marge de 0 % sur la page des frais de traitement du partenaire, il ne peut pas être mis en ligne ni accepter de paiements en ligne ; avec cette confirmation, aucun frais ne lui est facturé et vous payez les frais de Stripe sur ses paiements.',
  },
  buttons: {
    set_custom: 'Définir des frais personnalisés',
    edit: 'Modifier',
    cancel: 'Annuler',
    save: 'Enregistrer',
    reset_to_default: 'Rétablir par défaut',
  },
  toasts: {
    load_error: 'Impossible de charger les frais de traitement.',
    failed_to_save_changes: 'Impossible d’enregistrer les frais de traitement.',
    changes_got_saved: 'Frais de traitement enregistrés',
    reset_to_default: 'Ce restaurant utilise désormais vos frais de traitement par défaut.',
  },
};
